/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OrganisationPreferenceSchemaDto
 */
export interface OrganisationPreferenceSchemaDto {
    /**
     *
     * @type {string}
     * @memberof OrganisationPreferenceSchemaDto
     */
    preferenceType?: OrganisationPreferenceSchemaDtoPreferenceTypeEnum;
    /**
     * One of Int32, Decimal, Boolean, String
     * @type {string}
     * @memberof OrganisationPreferenceSchemaDto
     */
    dataType?: string;
    /**
     * Optional. The range (inclusive) of allowed values for a number, the character length for a string, or the list of allowed enums. eg: Int32: [0,100], Decimal: [0,99.9], String: [10,20], Boolean: null
     * @type {string}
     * @memberof OrganisationPreferenceSchemaDto
     */
    values?: string;
    /**
     *
     * @type {string}
     * @memberof OrganisationPreferenceSchemaDto
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof OrganisationPreferenceSchemaDto
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof OrganisationPreferenceSchemaDto
     */
    category?: string;
}

/**
 * @export
 */
export const OrganisationPreferenceSchemaDtoPreferenceTypeEnum = {
    Unknown: "Unknown",
    IncludeOfflineInUptimeCalculation: "IncludeOfflineInUptimeCalculation",
    LowEnergyDeliveryAcKwhThreshold: "LowEnergyDeliveryAcKwhThreshold",
    LowEnergyDeliveryDcKwhThreshold: "LowEnergyDeliveryDcKwhThreshold",
    LowEnergyDeliveryAcMinutesThreshold: "LowEnergyDeliveryAcMinutesThreshold",
    LowEnergyDeliveryDcMinutesThreshold: "LowEnergyDeliveryDcMinutesThreshold",
} as const;
export type OrganisationPreferenceSchemaDtoPreferenceTypeEnum =
    (typeof OrganisationPreferenceSchemaDtoPreferenceTypeEnum)[keyof typeof OrganisationPreferenceSchemaDtoPreferenceTypeEnum];

/**
 * Check if a given object implements the OrganisationPreferenceSchemaDto interface.
 */
export function instanceOfOrganisationPreferenceSchemaDto(
    value: object,
): value is OrganisationPreferenceSchemaDto {
    return true;
}

export function OrganisationPreferenceSchemaDtoFromJSON(
    json: any,
): OrganisationPreferenceSchemaDto {
    return OrganisationPreferenceSchemaDtoFromJSONTyped(json, false);
}

export function OrganisationPreferenceSchemaDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OrganisationPreferenceSchemaDto {
    if (json == null) {
        return json;
    }
    return {
        preferenceType:
            json["preferenceType"] == null ? undefined : json["preferenceType"],
        dataType: json["dataType"] == null ? undefined : json["dataType"],
        values: json["values"] == null ? undefined : json["values"],
        name: json["name"] == null ? undefined : json["name"],
        description:
            json["description"] == null ? undefined : json["description"],
        category: json["category"] == null ? undefined : json["category"],
    };
}

export function OrganisationPreferenceSchemaDtoToJSON(
    value?: OrganisationPreferenceSchemaDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        preferenceType: value["preferenceType"],
        dataType: value["dataType"],
        values: value["values"],
        name: value["name"],
        description: value["description"],
        category: value["category"],
    };
}
